import Swiper from 'swiper/bundle';

export default class Carousel {
  constructor(element) {
    this.element = element;
    this.options = {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: this.element.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next'),
        prevEl: this.element.querySelector('.swiper-button-prev'),
      },
    };

    this.init();
  }
  init() {
    this.setOptions();
    new Swiper(this.element, this.options);
  }
  setOptions() {
    // Split
    if ('split' in this.element.dataset) {
      this.options.breakpoints = {
        1024: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
        1: {
          slidesPerView: 1,
        },
      };
    }

    // Autoplay
    if ('autoplay' in this.element.dataset) {
      this.options.autoplay = {
        delay: 3000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      };
    }

    // Loop
    if ('loop' in this.element.dataset) {
      this.options.loop = true;
    }

    // Slides
    if ('slides' in this.element.dataset) {
      const slides = parseFloat(this.element.dataset.slides);
      this.options.slidesPerView = slides || this.options.slidesPerView;
    }

    // Gap
    if ('gap' in this.element.dataset) {
      if (this.element.dataset.gap == '0') {
        this.options.spaceBetween = 0;
      } else {
        const gap = parseFloat(this.element.dataset.gap);
        this.options.spaceBetween = gap || this.options.spaceBetween;
      }
    }
  }
}
